import type { TranslationTree } from '../../types';

export const home: TranslationTree = {
  home: {
    dashboard: {
      welcome: 'Bienvenue',
      description:
        "Suivez, analysez et anticipez la performance de vos outils sur l'ensemble de vos modules actifs.",
      scannerTitle: 'Traçabilité',
      scannerDescription: 'Scannez et suivez vos outils de fraisage',
      analyticsTitle: 'Analytique',
      analyticsDescription: 'Visualisez les performances et tendances',
      mlTitle: 'Machine Learning',
      mlDescription: "Prédisez l'usure et la durée de vie restante",
      toolViewTitle: 'Vue des outils',
      toolViewDescription: 'Parcourez et inspectez tous les outils enregistrés.',
      workshopTitle: 'Atelier',
      workshopDescription: "Enregistrez les opérations et sessions d'usinage.",
      labelizeTitle: 'Étiquetage',
      labelizeDescription:
        "Classifiez les images d'état des outils pour entraîner le modèle de maintenance prédictive.",
      toolRecommenderTitle: "Éco-conception d'outil",
      toolRecommenderDescription:
        'Trouvez les outils de coupe optimaux grâce à des recommandations par algorithme génétique.',
    },
  },
};
